<template>
	<div id="app">
		<configurator/>
	</div>
</template>

<script>
import configurator from './components/configurator.vue';

export default {
	name: 'app',
	components: {
		configurator
	}
}
</script>

<style lang="sass" scoped>
	#app::v-deep
		@import "../node_modules/bulma/bulma.sass"
</style>

<style lang="scss" scoped>
	#app::v-deep {
		@import "./assets/sass/main.scss";
	}
</style>
